<template>
  <div id="data-view">
    <dv-full-screen-container>
      <!--头部-->
      <topHeader></topHeader>
      <!--主-->
      <dv-border-box-1 class="main-container">
        <!--左-->
        <div class="left-chart-container box box_v">

          <div class="dc-text box box_v">
            <dv-decoration-3/>
          </div>
          <dv-border-box-13 class="dc-text-content">
            <div class="box box_around">

              <div class="box box_v box_i_center">
                <div class="dc-text-title">超市总消费</div>
                <div class="dc-text-num">{{toThousands(supermarketGoodsAmount, true)}}元</div>
              </div>

              <div class="box box_v box_i_center">
                <div class="dc-text-title">金银珠宝总消费</div>
                <div class="dc-text-num">{{toThousands(jewelryGoodsAmount, true)}}元</div>
              </div>

            </div>
          </dv-border-box-13>

          <!--排行榜-->
          <div class="box_f1">
            <div class="phb">
              <csscAllTable :type="'04'" :title="'超市总排行'"></csscAllTable>
              <csscAllTable :type="'07'" :title="'金银珠宝总排行'"></csscAllTable>
            </div>
          </div>

        </div>
        <!--中-->
        <div class="center-chart-container">

          <div class="rmc-top-container">
            <centerCmp></centerCmp>
          </div>

          <!--统计图-->
          <div class="rmc-center-container">
            <centerCharts></centerCharts>
          </div>


        </div>
        <!--右边-->
        <div class="right-chart-container box box_v">

          <div class="dc-text box box_v box_i_end">
            <dv-decoration-3/>
          </div>

          <dv-border-box-13>
            <div class="box box_around">

              <div class="box box_v box_i_center">
                <div class="dc-text-title">百货餐饮总消费</div>
                <div class="dc-text-num">{{toThousands(marketGoodsAmount, true)}}元</div>
              </div>

              <div class="box box_v box_i_center">
                <div class="dc-text-title">家电总消费</div>
                <div class="dc-text-num">{{toThousands(deviceGoodsAmount, true)}}元</div>
              </div>


            </div>
          </dv-border-box-13>


          <!--排行榜-->
          <div class="box_f1">
            <div class="phb">
              <csscAllTable :type="'05'" :title="'百货餐饮总排行'"></csscAllTable>
              <csscAllTable :type="'06'" :title="'家电总排行'"></csscAllTable>
            </div>
          </div>

        </div>

      </dv-border-box-1>
    </dv-full-screen-container>
  </div>
</template>

<script>
    import { demo_amountcount } from './demodata'
    import Vue from "vue";
    import topHeader from "./topHeader"
    import centerCharts from "./centerCharts"
    import centerCmp from "./centerCmp"
    import csscTable from './csscTable'
    import csscAllTable from './csscAllTable'
    import {  fullScreenContainer, borderBox1, borderBox6, borderBox8, borderBox9, borderBox13,
              decoration1, decoration3, decoration5, decoration7, decoration8, decoration10,
              charts, scrollBoard, loading } from '@jiaminghi/data-view'
    Vue.use(fullScreenContainer)
    Vue.use(loading)
    Vue.use(borderBox1)
    Vue.use(borderBox6)
    Vue.use(borderBox8)
    Vue.use(borderBox9)
    Vue.use(borderBox13)
    Vue.use(decoration1)
    Vue.use(decoration3)
    Vue.use(decoration5)
    Vue.use(decoration7)
    Vue.use(decoration8)
    Vue.use(decoration10)
    Vue.use(scrollBoard)
    Vue.use(charts)
    export default {
        name: "mainPage",
        computed: {
          xiaofeiquanVue() {
            return this.$store.state.xiaofeiquanVue
          },
        },
        data() {
          return {
            jewelryGoodsAmount: 0,
            supermarketGoodsAmount: 0,
            deviceGoodsAmount: 0,
            marketGoodsAmount: 0,
          }
        },
        created() {
            this.load()
        },
        methods: {
          load() {
            // 4大类总消费金额统计
            //this.xiaofeiquanVue.loopAxios('demo/api/coupon-count/ctt2/amount/count',{},res=> {
              let res = demo_amountcount
              if(res.newPrimaryKeys) {
                if(res.newPrimaryKeys.jewelryGoodsAmount) {
                  this.jewelryGoodsAmount = res.newPrimaryKeys.jewelryGoodsAmount
                }
                if(res.newPrimaryKeys.supermarketGoodsAmount) {
                  this.supermarketGoodsAmount = res.newPrimaryKeys.supermarketGoodsAmount
                }
                if(res.newPrimaryKeys.deviceGoodsAmount) {
                  this.deviceGoodsAmount = res.newPrimaryKeys.deviceGoodsAmount
                }
                if(res.newPrimaryKeys.marketGoodsAmount) {
                  this.marketGoodsAmount = res.newPrimaryKeys.marketGoodsAmount
                }
              }
            //})
          },
          toThousands(_num, bol) {
            _num = _num.toFixed(4)*1
            let numArr = (_num+'').split('.')
            let num = parseInt(numArr[0])
            let xs = numArr[1]?numArr[1]:''

            let result = [ ], counter = 0;
            num = (num || 0).toString().split('')
            for (let i = num.length - 1; i >= 0; i--) {
              counter++
              result.unshift(num[i])
              if (!(counter % 3) && i != 0) { result.unshift(','); }
            }
            if(xs) {
              result = [...result, '.', ...xs.split('')]
            }
            if(bol) {
              return result.join('')
            }else {
              return result
            }
          }
        },
        components: { topHeader, centerCmp, centerCharts, csscTable, csscAllTable }
    }
</script>

<style lang="less">
  @import "img/index.css";
  #data-view {
    width: 100%;
    height: 100%;
    background-color: #030409;
    color: #fff;
    #dv-full-screen-container {
      background-image: url('./img/guang1.png'), url('./img/bg.jpg');
      background-size: 110% 70%, 100% 100%;
      background-position: center top, center top, center;
      background-repeat: no-repeat;
      box-shadow: 0 0 3px blue;
      display: flex;
      flex-direction: column;

    }
    .main-container {
      height: 100%;
      .border-box-content {
        position: relative;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
      }
    }
    .left-chart-container, .right-chart-container {
      width: 32%;
      height: 100%;
      /*padding: 0 10px;*/
      position: relative;
      box-sizing: border-box;
      .border-box-content {
        flex-direction: column;
      }

      .dv-border-box-13 {
        height: 90px;
      }

      .dc-text-title {
          font-size: 16px;
      }

      .dc-text-num {
        font-size: 18px;
        margin-top: 5px;
        color: rgb(255, 252, 134);
      }
    }
    .phb {
      width: 100%;
      height: 100%;
      padding: 0;
      margin: 0;
      position: relative;
      box-sizing: border-box
    }
    .dc-text {
      font-size: 18px;
      .dv-decoration-3 {
        width: 100px;
        height: 20px;
      }
    }

    .center-chart-container {
      width: 36%;
      padding: 0 10px 10px 10px;
      box-sizing: border-box;
      position: relative;
      .border-box-content {
        position: relative;
        flex-direction: column;
      }

      .rmc-top-container {
        position: relative;
        height: 30%;
        display: flex;
      }
      .rmc-center-container {
        position: relative;
        height: 70%;
      }
    }
  }
</style>
